module.exports = __webpack_public_path__ + "fonts/iconfont.6b7ad8d4.woff2";